import {Component, computed, signal, ChangeDetectionStrategy} from "@angular/core"
import {BaseInspectorComponent} from "@app/template-editor/components/inspectors/base-inspector/base-inspector.component"
import {InspectorSectionComponent} from "@app/template-editor/components/inspectors/inspector-section/inspector-section.component"
import {SelectionPossibilities, ValueSlotComponent} from "@app/template-editor/components/value-slot/value-slot.component"
import {getLodTypeDescription, getTemplateNodeClassLabel, LodType as LodTypeNode, type LodTypeValue} from "@cm/template-nodes"

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-lod-type-inspector",
    templateUrl: "./lod-type-inspector.component.html",
    styleUrl: "./lod-type-inspector.component.scss",
    imports: [InspectorSectionComponent, ValueSlotComponent],
})
export class LodTypeInspectorComponent extends BaseInspectorComponent<LodTypeNode> {
    readonly $class = computed(() => getTemplateNodeClassLabel(this.$node()))

    readonly $lodTypePossibilites = signal<SelectionPossibilities<LodTypeValue>>([
        {value: "web", name: getLodTypeDescription("web")},
        {value: "ar", name: getLodTypeDescription("ar")},
        {value: "pathTraced", name: getLodTypeDescription("pathTraced")},
    ])
}
